import React, { useCallback } from 'react';

import { Stack } from '@lyearn/ui';

import { useDesignContext } from '../../context/Design';
import { DesignCard } from '../../enums';
import Card from '../Card';
import { SidebarProps } from './types';

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { cardContents } = props;
  const { setOverlayContent } = useDesignContext();

  const onCardClick = useCallback(
    (type: DesignCard) => {
      setOverlayContent({ type });
    },
    [setOverlayContent],
  );

  return (
    <Stack alignItems="center" className="px-16 pt-8" direction="col">
      {cardContents.map((content) => (
        <Card
          key={content.type}
          content={content}
          disabled={content.disabled}
          onClick={onCardClick}
        />
      ))}
    </Stack>
  );
};

export default Sidebar;
